import { useQuery } from 'react-query';
import { fetchNetflixOriginals } from '../services/api';

export const useNetflixOriginals = options => {
  return useQuery('netflixOriginals', fetchNetflixOriginals, options);
};
